// extracted by mini-css-extract-plugin
export default {"image":"AddImageCard_image__-TzvG","image__inner":"AddImageCard_image__inner__rDeEO"};